import { keyframes } from 'styled-components';
import styled, { css } from 'foundations-theming-specialty/utils';
import { getAccountMenuBorder, getAccountMenuItemPadding } from '../shared-styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const loadingAnimation = keyframes(["0%{background-color:hsl(200,20%,80%);}100%{background-color:hsl(200,20%,95%);}"]);
const StyledLi = styled.li.withConfig({
  displayName: "Loading__StyledLi",
  componentId: "spfwu5-0"
})(({
  theme
}) => ({
  listStyleType: 'none',
  borderBottom: `${getAccountMenuBorder(theme)} !important`,
  padding: `${getAccountMenuItemPadding(theme)} !important`,
  display: 'block'
}));
const AnimatedDiv = styled.div.withConfig({
  displayName: "Loading__AnimatedDiv",
  componentId: "spfwu5-1"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["animation:", " 1s linear infinite alternate;width:100%;height:15px;margin-bottom:", " !important;border-radius:", ";&:first-of-type{width:33% !important;margin-top:", " !important;}&:last-of-type{width:90% !important;}"], loadingAnimation, theme.space['200'], theme.borderRadius['100'], theme.space['200']);
});
const Loading = () => {
  return /*#__PURE__*/_jsxs(StyledLi, {
    "data-test-id": "nav-account-onboarding-loading",
    children: [/*#__PURE__*/_jsx(AnimatedDiv, {}), /*#__PURE__*/_jsx(AnimatedDiv, {})]
  });
};
export default Loading;